<template>
    <div class="content-error">
        <i class="fas fa-exclamation-circle"></i>
        <h3>{{Language.say(props.title_text)}}</h3>
        <p>{{Language.say(props.info_text)}}</p>
        <ActionButton
            @click='onRetryClick()'
            class='top-space'
            icon='fas fa-redo-alt'
            :text="props.button_text"
        />
    </div>
</template>

<script setup>
  import {defineProps, defineEmits} from 'vue';
  import Language                   from '@/js/Shared/Language/Language.js';
  import ActionButton               from '@/vue/Elements/Buttons/ActionButton.vue'

  const emit = defineEmits([
    'contentErrorRetry',
  ]);

  const props = defineProps({
    title_text : {
      default: 'global.content.error.title',
    },

    info_text : {
      default: 'global.content.error.info',
    },

    button_text : {
      default: 'global.content.error.retry',
    }
  })

  const onRetryClick = () => {
    emit('contentErrorRetry');
  }
</script>
